<template>
  <div class="eat-promos" @click="scroll = false">
    <div v-if="selected" class="selected has-text-grey" @click="clearSelected">
      <span style="white-space: nowrap; overflow: hidden">{{
        selected.name
      }}</span>
      <button class="delete" style="margin-right: -7px; margin-top: 2px" />
    </div>
    <div
      class="buttons is-centered single-line gpu-accelerated"
      v-on:scroll.passive="scroll = false"
      :key="z"
    >
      <p
        v-for="(p, i) in promos"
        :key="p.name + p.rank"
        class="promo button"
        :class="{ pulse: i === pulseIdx }"
        :style="bgColor(p, i)"
        @click="setFilter(p, i)"
      >
        <!-- v-webp:bg="p.pic" -->
        <span v-show="!p.pic">{{ p.name }}</span>
      </p>
    </div>
    <div v-if="isIOSApp()" style="height: 6px" />
    <div v-if="scroll" class="more-arrow" />
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "EatPromos",
  data() {
    return {
      pulseIdx: null,
      selected: null,
      colors: [
        "#FF9AA2",
        "#C7CEEA",
        "#FFDAC1",
        "#B5EAD7",
        "#FFB7B2",
        "#E2F0CB",
        "#FF9AA2", // 7 is duplicate of 1
        "#C7CEEA", // 8 is duplicate of 2
      ],
      old: [
        { name: "Free Delivery", tag: "*free-delivery" },
        { name: "Pizza", tag: "Pizza" },
        { name: "Mexican", tag: "Mexican" },
        { name: "American", tag: "American" },
        { name: "Thai Food", tag: "thai" },
        { name: "Desserts", tag: "Desserts" },
      ],
      lists: this.$store.state.eatLists, //[],
      loading: false, //
      scroll: false,
      pulseTimer: null, // for blue pulse
      z: 0,
    };
  },
  computed: {
    promos() {
      if (!this.lists.length) return this.old;
      return this.lists.map((l) => {
        return l.data;
      });
    },
  },
  mounted() {
    this.checkScrollable(); // triggers gold pulse
  },
  activated() {
    this.getBlobs();
  },
  methods: {
    checkScrollable() {
      var el = this.$el.querySelector(".buttons");
      if (el.scrollWidth > window.innerWidth) {
        setTimeout(() => (this.scroll = true), 3000);
      } else this.scroll = false;
    },
    setDefault() {
      var query = this.$route.query; // look for s for search
      if (query.s) return; // don't set default if has query
      if (this.selected) return; // don't set default if something already selected
      this.selected = this.promos[0];
      this.pulseIdx = 0;
      this.setFilter(this.promos[0], 0);
    },
    getBlobs() {
      // use $store.state
      var region = this.$store.state.region || "Chiang Mai"; // fallback to chiang mai if not set
      var pageRegion = { page: "Eat", region: region }; // region shouldn't be hard coded
      this.$store
        .dispatch("getBlobsForList", pageRegion)
        .then((res) => {
          if (!res.data) return;
          this.$store.commit("setEatLists", res.data);
          // this.lists  this.$store.state.eatLists
          this.lists = res.data;
          this.setDefault();
          setTimeout(() => this.checkScrollable(), 1000);
          this.z += 1;
        })
        .catch((err) => console.error("getBlobs eat promos", err));
      //
    },
    bgColor(p, idx) {
      var lang = this.$store.state.language;
      var key = `pic_${lang}`; // pic_en, pic_th etc
      if (p[key]) return `background-image: url('${p[key]}');`;
      if (p.pic) return `background-image: url('${p.pic}');`;
      return `background-color: ${this.colors[idx]}`; // if no pic use default color
    },
    setFilter(l, idx) {
      this.log("eat_list", l);
      if (!l) return; // if filter string / tag is empty... shouldn't happen
      var f = l.tag;
      f = f.toLowerCase(); // lowercase just in case
      this.selected = l;
      this.pulseIdx = idx;
      clearTimeout(this.pulseTimer);
      this.pulseTimer = setTimeout(() => (this.pulseIdx = null), 5000);
      // if (f[0] === "%2a") f[0] = "*";
      if (f[0] === "*") {
        this.search(null);
        EventBus.$emit("SET_EAT_FILTER", f); // *open-now, *free-delivery, *for-you
        return;
        // if (f === "*open-now") {
        //   this.search(null);
        //   return EventBus.$emit("SET_EAT_FILTER", f);
        // }
        // if (f === "*free-delivery") {
        //   EventBus.$emit("SET_EAT_FILTER", f);
        //   return this.search(null);
        // }
        // if (f === "*for-you") {
        //   EventBus.$emit("SET_EAT_FILTER", f);
        //   return this.search(null);
        // }
      }
      return this.search(f);
    },
    search(s) {
      EventBus.$emit("SHOP_LIST_SEARCH", s);
      EventBus.$emit("SET_EAT_FILTER", null);
    },
    clearSelected() {
      this.selected = null;
      this.pulseIdx = null;
      this.search(null);
      this.$emit("focusSearch");
    },
  },
};
</script>

<style scoped>
/* .eat-promos {
  max-width: 700px;
} */
.buttons {
  width: 100vw;
  max-width: 700px;
  /* margin: auto; */
  padding: 6px 4px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
.promo {
  white-space: normal;
  margin: 5px;
  background-color: lightblue;
  font-family: "Bowlby One SC", cursive;
  font-weight: 500;
  /* font-size: calc(100vw / 60px) * 1vw; */
}
.promo {
  border-radius: 3px;
  height: 90px;
  width: 90px;
  border: 1px solid white;
  /* border: 1px solid #d3d3d4; */
  /* box-shadow: 0 0 0 2pt #f5d252, 2px 2px 4px rgba(0, 0, 0, 0.35); */
  /* box-shadow: 0 0 0 1.5px #d3d3d4, 2px 2px 3px rgba(0, 0, 0, 0.35); */
  box-shadow: 0 0 0 1px #e7e7e7, 1px 1px 3px rgba(0, 0, 0, 0.35);
}
.dark .promo {
  /* border: 3px solid #2693da; */
  border: 1px solid #123;
}
/* .button:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
} */
.buttons::-webkit-scrollbar {
  display: none;
}
.pulse {
  margin: 5px;
  animation: shadow-pulse 1s infinite;
}
p {
  background-size: cover;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px cyan;
  }
  100% {
    box-shadow: 0 0 0 6px rgba(0, 255, 255, 0.445);
  }
}
.more-arrow {
  position: fixed;
  /* right: 0px; */
  /* right: max(calc((100vw - 700px) / 2), 0px); */
  left: min(calc(50vw + (700px / 2)), 100vw);
  top: 74px;
  width: 2px;
  height: 64px;
  border-radius: 50%;
  background-color: gold;
  animation: shadow-pulse-gold 2s infinite;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px gold;
  }
  100% {
    box-shadow: 0 0 0 15px rgba(255, 217, 0, 0.7);
  }
}
.selected {
  position: absolute;
  top: 13px;
  margin-left: 88px;
  /* left: 88px; */
  /* background-color: #ffdd57; */
  background-color: #fff4c7;
  padding: 3px 8px;
  border-radius: 2px;
  font-weight: 450;
  /* font-weight: 500;
  color: grey !important; */
  width: calc(100vw - 193px);
  max-width: calc(700px - 193px);
  text-align: left;
}
.delete {
  position: absolute;
  right: 12px;
  top: 3px;
  /* float: right; */
}
.dark .selected {
  /* background-color: lightskyblue; */
  background-color: rgb(202, 235, 255);
}
</style>